/**
 * @module app.track.share
 */

class Controller {

  /**
   * @param {ngeo.statemanager.Location} ngeoLocation ngeo Location service.
   * @param {app.track.service} appTrackService
   * @ngInject
   */
  constructor(ngeoLocation, appTrackService) {

    /**
     * @private
     */
    this.ngeoLocation_ = ngeoLocation;

    /**
     * @private
     */
    this.trackService_ = appTrackService;

    /**
     * @private
     */
    this.track_ = appTrackService.selectedTrack;

    /**
     * @type {string}
     * @export
     */
    this.href = ngeoLocation.getUriString();
  }

  get public() {
    return this.track_.properties.public;
  }

  set public(val) {
    if (this.track_.properties.public !== val) {
      this.track_.properties.public = val;
      this.trackService_.saveTrackConfig(this.track_);
    }
  }

  /**
   * @export
   */
  sendLinkByEmail() {
    window.location.href = `mailto:?body=${encodeURIComponent(this.href)}`;
  }

}

/**
 * @const {!angular.Component}
 */
const component = {
  controller: Controller,
  templateUrl: 'js/app/track/share/partial.html'
};

export default angular.module('appTrackShareComponent', []).component('appTrackShare', component);
